export default __webpack_public_path__ + "static/media/notFoundNewNoBg.e17bc581.png";